import { render, staticRenderFns } from "./base_aggregator_settings.vue?vue&type=template&id=25f4c71b&scoped=true&"
import script from "./base_aggregator_settings.vue?vue&type=script&lang=js&"
export * from "./base_aggregator_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4c71b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f4c71b')) {
      api.createRecord('25f4c71b', component.options)
    } else {
      api.reload('25f4c71b', component.options)
    }
    module.hot.accept("./base_aggregator_settings.vue?vue&type=template&id=25f4c71b&scoped=true&", function () {
      api.rerender('25f4c71b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/settings/base_aggregator_settings.vue"
export default component.exports